import { render, staticRenderFns } from "./unilevel.vue?vue&type=template&id=38b27316&scoped=true"
import script from "./unilevel.vue?vue&type=script&lang=js"
export * from "./unilevel.vue?vue&type=script&lang=js"
import style0 from "./unilevel.vue?vue&type=style&index=0&id=38b27316&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38b27316",
  null
  
)

export default component.exports